import { Box, Drawer } from '@mui/material';
import React from 'react';

export interface ActionDrawerProps {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

const ActionDrawer: React.FC<ActionDrawerProps> = ({
  open,
  onClose,
  children,
}) => (
  <Drawer
    anchor="bottom"
    open={open}
    onClose={onClose}
    sx={{
      '& .MuiDrawer-paper': {
        borderTopLeftRadius: 16,
        borderTopRightRadius: 16,
        maxHeight: '90vh',
      },
    }}
  >
    <Box sx={{ pt: 1.5, pb: 3, px: 2 }}>
      <Box
        sx={{
          width: 40,
          height: 4,
          borderRadius: 2,
          backgroundColor: 'action.selected',
          mx: 'auto',
          mb: 2,
        }}
        aria-hidden
      />
      {children}
    </Box>
  </Drawer>
);

export default ActionDrawer;
